module.exports = {
      id: "tick-usage",
      viewBox: "0 0 23.788 23.787",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#tick",
      toString: function () {
        return this.url;
      }
    }